import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * The merchant arrives thinking "connect Grow" is a settings toggle. It is a bank-grade account
 * opening reviewed by a stranger. This sets that expectation without scaring them off -- and
 * deliberately says nothing about pricing, which is Grow's to communicate, and nothing that
 * sounds like Monkeybook is the one approving them.
 */
export const GrowConnectIntro = () => {
  const { t } = useTranslation();
  const checklist = [
    t('growConnect.intro.checklistOwnerId'),
    t('growConnect.intro.checklistBankDetails'),
    t('growConnect.intro.checklistBusinessNumber'),
  ];

  return (
    <Grid container flexDirection="column" gap={1.5}>
      <Typography>{t('growConnect.intro.lead')}</Typography>

      <Grid container flexDirection="column">
        <Typography fontWeight={700}>{t('growConnect.intro.checklistTitle')}</Typography>
        <ul style={{ margin: '4px 0', paddingInlineStart: '20px' }}>
          {checklist.map((item) => (
            <li key={item}>
              <Typography>{item}</Typography>
            </li>
          ))}
        </ul>
      </Grid>

      <Typography>{t('growConnect.intro.ownerMustFill')}</Typography>
      <Typography>{t('growConnect.intro.reviewTakesTime')}</Typography>
    </Grid>
  );
};
